import React, { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";
import { numberWithCommas } from "../../utils";
import ReactECharts from "echarts-for-react";
import { useCustomTranslation } from "../../hooks/useCustomTranslation";

const ChartComponent = ({ data, title }) => {
  const echartRef = useRef(null);
  const [chartOption, setChartOption] = useState({});
  const { t } = useCustomTranslation("Tableau de bord");

  useEffect(() => {
    onResizeEvent();
    resizeHandler();

    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, []);

  useEffect(() => {
    const totalAmount = data.reduce((acc, campaign) => acc + campaign.value, 0);

    const option = {
      title: {
        text: title,
      },
      responsive: true,
      tooltip: {
        trigger: "item",
        formatter: (params) => {
          const percent = `${params.percent}%`;
          const campaignName = params.name;
          const amount = params.value;
          return `<strong>${t(
            "pie_chart_slice_name"
          )}:</strong> ${campaignName}<br><strong>${t(
            "pie_chart_slice_amount"
          )}:</strong> ${numberWithCommas(amount)}$<br>(${percent} ${t(
            "pie_chart_slice_summary"
          )}: <strong>${numberWithCommas(totalAmount)}$</strong>)`;
        },
      },
      grid: {
        left: "35px",
        right: "10px",
        top: "45px",
        bottom: "25px",
      },
      series: [
        {
          name: "Access From",
          type: "pie",
          radius: "75%",
          data: data.map((transaction_data) => ({
            name: transaction_data.name,
            value: transaction_data.value,
            label: {
              formatter: `{b}: {d}%`,
            },
          })),
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          color: [
            "#3B82F6",
            "#10B981",
            "#A855F7",
            "#06B6D4",
            "#1D4ED8",
            "#059669",
            "#7C3AED",
            "#0891B2",
            "#4F46E5",
            "#6EE7B7",
          ],
        },
      ],
    };

    if (option && typeof option === "object") {
      setChartOption({ ...option });
    }
  }, [data, title]); // Update the chart when data or title changes

  const onResizeEvent = () => {
    // Add event listener
    window.addEventListener("resize", resizeHandler);
  };

  const resizeHandler = () => {
    if (echartRef.current) {
      const echartInstance = echartRef.current.getEchartsInstance();
      if (echartInstance) {
        echartInstance.resize();
      }
    }
  };

  return (
    <>
      <ReactECharts
        ref={echartRef}
        option={chartOption}
        style={{ height: "100%", width: "100%" }}
        lazyUpdate={true}
        notMerge={true}
      />
    </>
  );
};

export default ChartComponent;
